import {createStyles, Theme} from "@material-ui/core";
import {primaryColor, styleColors} from "src/main.style";

export const BottomBarStyle = (theme: Theme) => createStyles({
  footer : {
    minHeight: '76px',
    maxHeight: '76px',
    zIndex: 10,
    position: 'absolute',
    width: '100%',
    bottom: 0,
    backgroundColor: styleColors.greyLight2,
    borderTop: `0.5px solid ${styleColors.greyMedium1}`,
    boxShadow: `0px 0px 10px ${styleColors.chromePurpleShadow}`,
    overflow: 'hidden',
    transition: 'all 0.5s',
    boxSizing: 'border-box',
    justifyContent: 'space-evenly',
    display: 'flex',
    alignItems: 'center',
    padding: '0px 12px',
    paddingBottom: '20px',
  },
  FAB : {
    position: 'absolute',
    bottom: '100px',
    minWidth: '62px',
    minHeight: '62px',
    right: '20px',
    backgroundColor: styleColors.greyLight2,
    zIndex: 2,
    borderRadius: '100px',
    transition: 'all 0.5s',
    boxShadow : `0px 3px 30px ${styleColors.greyOverlay35}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  FABHidden : {
    transform:'scale(0)',
    pointerEvents:'none', 
    opacity:0,
  },
  icon : {
    position:'relative',
  },
  badge : {
    top: 0,
    right: 0,
    color: styleColors.white,
    backgroundColor: primaryColor,
    fontSize: '12px',
    minWidth: '14px',
    minHeight: '14px',
    padding: '1px',
    borderRadius: '10px',
    position:'absolute',
    transition: 'transform 160ms ease',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 400,
    fontFamily: 'Metropolis',
    pointerEvents: 'none',
  },
  iconButton : {
    minWidth: '48px',
    position: 'relative',
    minHeight: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: styleColors.greyDark1,
    boxSizing: 'border-box',
    padding: '12px',
  },
  famName: {
    position: 'absolute',
    bottom: '6px',
    pointerEvents: 'none',
    opacity: '0.5',
    fontSize: '10px',
    letterSpacing: '1px',
    width: '100%',
    textAlign: 'center',
  }
});




// WEBPACK FOOTER //
// ./src/components/calendar2/fab/BottomBar.style.ts